module.exports = __webpack_public_path__ + "img/userFormal.f1b8ee13.png";